var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null);
var device = require('../lib/device.js');

function Parallax() {
  if(device.isDefinitelyMobile) {
    this.disabled = true;
  }

  this.cssParallax = (device.isWebkit && device.isDefinitelyDesktop && device.browser !== 'safari') && (window.location.search.indexOf('test') == -1);

  this.init();
}

Parallax.prototype.init = function() {
  if(this.disabled) {
    return;
  }

  this.elements = $('[data-parallax-parent]');

  $(window).off('scroll.vsc-parallax');

  if(this.elements.length) {
    if(this.cssParallax) {
      $('html').addClass('css-parallax');
    } else {
      $(window).on('scroll.vsc-parallax', this.renderElements.bind(this));
    }
  } else {
    $('html').removeClass('css-parallax');
  }
}

Parallax.prototype.renderElements = function() {
  var scrollY = window.pageYOffset;
  
  for(var i = 0; i < this.elements.length; i++) {
    var parallaxEl = this.elements[i];

    var scrollPercent = scrollY / parallaxEl.offsetHeight;

    if(scrollPercent <= 1 && scrollPercent >= -1) {
      var perspectiveOrigin = (scrollPercent + 0.5) * 100;
      var perspectiveStyle = 'perspective-origin: 50% '+perspectiveOrigin+'%';
      var prefixedStyle = '-webkit-'+perspectiveStyle+'; '+perspectiveStyle+';';
      parallaxEl.setAttribute('style', prefixedStyle);
    }
  }
}

module.exports = Parallax;
